import BaseService from './base.service';

export default class UserService extends BaseService {
  async changePassword(currentPassword, newPassword) {
    await this.put('/users/password', { currentPassword, newPassword });
  }

  async updateDetails(userDetails) {
    return this.put('/users/current-user', userDetails);
  }

  async getCurrentUser() {
    return this.get('/users/current-user');
  }

  async searchUsers(name) {
    return this.get(`/users/search?name=${name}`);
  }

  async changeEmailRequest() {
    return this.post('/users/change-email-request');
  }

  async validateMfaChangeEmail({ token }) {
    return this.post('/users/validate-mfa-change-email', { mfaNumber: token });
  }

  async changeEmail({ token, email }) {
    return this.post('/users/change-email', { email, tokenNumber: token });
  }

  async updateUserOrderStatusToDemo() {
    return this.put('/users/order-status-demo');
  }

  async deleteUser(userId) {
    return this.delete(`/users/${userId}`);
  }

  async getUsers(criteria) {
    const { page = 0, limit = 10, orderField, orderType, roles, status, facilityId, departmentId, search, modality } = criteria;
    let url = `/users/workspace-users?page=${page}&limit=${limit}`;

    if (orderField && orderType) {
      url += `&orderField=${orderField}&orderType=${orderType}`;
    }

    if (status) {
      url += `&status=${status}`;
    }

    if (roles) {
      url += `&roles=${roles.join(',')}`;
    }

    if (facilityId) {
      url += `&facilityId=${facilityId}`;
    }

    if (departmentId) {
      url += `&departmentId=${departmentId}`;
    }

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    if (modality && modality.length > 0) {
      url += `&modality=${modality.join(',')}`;
    }

    return this.get(url);
  }

  async inviteUser(userData) {
    return this.post('/users/invite-techqa', userData);
  }

  async resendInvitation(userId, data) {
    return this.post(`/users/resend-invitation/${userId}`, data);
  }

  async disableUser(userId) {
    return this.put(`/users/${userId}/disable`);
  }

  async enableUser(userId) {
    return this.put(`/users/${userId}/enable`);
  }

  async updateUser(userId, userData) {
    return this.put(`/users/${userId}`, userData);
  }

  async importUsers(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.sendFormData('POST', '/users/import', formData);
  }

  async importUsersData(users) {
    return this.post('/users/import-users', { users });
  }

  async validateUsersBulk(users) {
    return this.post('/users/validate-bulk', { users });
  }
}
